// client/src/index.js
import React from 'react';
import { createRoot } from 'react-dom/client';
import './utils/i18n'; // Import i18n configuration before App
import App from './App';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);